import { Navigate, Route, Routes } from "react-router-dom";

import styled from "styled-components";

import LabPublicPage from "../pages/lab-public-page";
import RecoveryPage from "../pages/recover-page";

import BookingsListPage from "components/pages/bookings-list-page";
import CreateBookingPage from "components/pages/create-booking-page";
import CreateEventBookingPage from "components/pages/create-event-booking-page";
import DormitoriesPage from "components/pages/dormitories-page";
import MyClubsPage from "components/pages/my-clubs-page";
import EditDormitoryPage from "components/pages/dormitory-editor/edit-dormitory-page";
import DormitoryPublicPage from "components/pages/dormitory-public-page";
import EventRequestsPage from "components/pages/event-requests-page";
import EventRequestsPreviewPage from "components/pages/event-requests-preview-page";
import EventsPage from "components/pages/events-page";
import EventsPublicPage from "components/pages/events-public-page";
import LabsPage from "components/pages/labs-page";
import NotificationsPage from "components/pages/notifications-page";
import PreviewBookingPage from "components/pages/preview-booking-page";
import RequestsPage from "components/pages/requests-page";
import ReviewsPage from "components/pages/reviews-page";
import SearchResultsPage from "components/pages/search-results-page";
import UniDashboardPage from "components/pages/uni-dashboard-page";
import UniProfileInfoPage from "components/pages/uni-profile-info-page";
import UniversityPublicPage from "components/pages/university-public-page";
import Header from "components/tools/header";
import { Frame } from "components/ui-kit/styled-templates";

import useProfileInfoCompleted from "hooks/useProfileInfoCompleted";
import DevPage from "../pages/dev-app";
import AmbassadorsListPage from "../pages/ambassadors-list-page";
import AmbassadorPage from "../pages/ambassador-page";
import MyClubsStatsPage from "../pages/my-clubs-stats-page";
import ClubPublicPage from "../pages/club-public-page";

const UniversityApp = () => {
    const profileInfoCompleted = useProfileInfoCompleted();

    if (profileInfoCompleted === undefined) {
        return null;
    }

    return (
        <>
            <Wrapper>
                <Header />
                {profileInfoCompleted ? (
                    <Routes>
                        <Route path="/dashboard" element={<UniDashboardPage />} />
                        <Route path="/recover/:recoveryKey" element={<RecoveryPage />} />
                        <Route path="/dormitories" element={<DormitoriesPage />} />
                        <Route path="/clubs" element={<MyClubsPage />} />
                        <Route path="/club/:clubId" element={<ClubPublicPage/>} />
                        <Route path="/stats-clubs" element={<MyClubsStatsPage />} />
                        <Route path="/profile-info" element={<UniProfileInfoPage />} />
                        <Route path="/notifications" element={<NotificationsPage />} />
                        <Route path="/events" element={<EventsPage />} />
                        <Route path="/ambassadors" element={<AmbassadorsListPage />} />
                        <Route path="/ambassadors/:ambassadorId" element={<AmbassadorPage />} />
                        <Route path="/ambassadors/:ambassadorId/posts/:postId" element={<AmbassadorPage />} />
                        <Route path="/labs" element={<LabsPage />} />

                        <Route path="/reviews" element={<ReviewsPage />} />

                        <Route path="/events/:eventId" element={<EventsPublicPage />} />
                        <Route path="/security" element={() => null} />
                        <Route path="/dormitories/:dormitoryId" element={<EditDormitoryPage />} />
                        <Route path="/dormitory/:dormitoryId" element={<DormitoryPublicPage />} />
                        <Route path="/lab/:labId" element={<LabPublicPage />} />
                        <Route path="/search" element={<SearchResultsPage />} />
                        <Route path="/bookings" element={<BookingsListPage />} />
                        <Route path="/edit-booking/:bookingId" element={<CreateBookingPage mode="edit" />} />
                        <Route path="/requests" element={<RequestsPage />} />
                        <Route path="/event-requests" element={<EventRequestsPage />} />
                        <Route path="/event-request-preview/:requestId" element={<EventRequestsPreviewPage />} />
                        <Route path="/edit-event-booking/:requestId" element={<CreateEventBookingPage mode="edit" />} />
                        <Route path="/preview-booking/:bookingId" element={<PreviewBookingPage />} />
                        <Route path="/university/:universityId" element={<UniversityPublicPage />} />
                        <Route path="/dev" element={<DevPage />} />
                        <Route path="/*" element={<Navigate to="/dashboard" />} />
                    </Routes>
                ) : (
                    <Routes>
                        <Route path="/profile-info" element={<UniProfileInfoPage />} />
                        <Route path="/*" element={<Navigate to="/profile-info" />} />
                    </Routes>
                )}
                {/*<FooterComponent/>*/}
            </Wrapper>
        </>
    );
};

export const Wrapper = styled(Frame).attrs((props) => {
    return { ...props, id: "scrollWrapper" };
})`
    width: 100%;
    flex: 1;
    min-height: 100vh;
    justify-content: flex-start;
    /* padding: 35px 0; */
    box-sizing: border-box;
    flex: 1;
    display: flex;
    overflow: auto;
    max-height: 100vh;
    overflow-x: hidden;
`;

export default UniversityApp;
